enum EParticipantHeaderVariant {
    Default = "default",
    Onboarding = "onboarding"
}

export { EParticipantHeaderVariant }
